import {
  BooleanParam,
  DateTimeParam,
  StringParam,
  withDefault,
} from 'use-query-params';

import { SearchPlayerRewardsOrderBy } from '@/globalTypes';
import {
  PlayerRewardStatusParam,
  SearchPlayerRewardsOrderByParam,
} from '@/utils/query/params';

export const queryParams = {
  playerId: StringParam,
  desc: withDefault(BooleanParam, true),
  rewardStatus: PlayerRewardStatusParam,
  assignationId: StringParam,
  assignedAtFrom: DateTimeParam,
  assignedAtTo: DateTimeParam,
  orderBy: withDefault(
    SearchPlayerRewardsOrderByParam,
    SearchPlayerRewardsOrderBy.assignedAt,
  ),
  before: StringParam,
  after: StringParam,
};
